import { defineStore } from 'pinia'
import { httpHelper } from '@/utils/helper/http.helper'
import { httpSuppMoDlCmmDlvyCommUpdateDlvyPosit } from '@/service/apis/supp/mo/dl.api'

export const useAPPstore = defineStore({
  id: 'useAPPstore',

  state: () => ({
    showNetworkAlert: false,
    networkAlertMsg: '통신 오류 입니다. 관리자 문의 해주세요.',
    authInfo: {},
    deviceInfo: {
      dvicId: 'string',
      dvicModelNm: 'web',
      dvicFltfNm: 'android',
      dvicFltfNmVer: '0',
      appPkgVer: '1.0.0',
      appId: 'com.gsr.mgssm.dev'
    },
    keyboardHeight: 0,
    refreshCallback: () => {}
  }),

  actions: {
    setShowNetworkAlert(isShow) {
      this.showNetworkAlert = isShow
    },
    setNetworkAlertMsg(msg) {
      this.networkAlertMsg = msg
    },
    async actionHttpSuppMoDlCmmDlvyCommUpdateDlvyPosit(fdata) {
      try {
        const response = await httpHelper(httpSuppMoDlCmmDlvyCommUpdateDlvyPosit, fdata)
        console.debug('httpSuppMoDlCmmDlvyCommUpdateDlvyPosit response :', response)
        return response
      } catch (error) {
        console.debug('httpSuppMoDlCmmDlvyCommUpdateDlvyPosit error :', error)
        return error.response.data
      }
    }
  }
})
